export var MessageType;
(function (MessageType) {
    MessageType["ERROR"] = "ERROR";
    MessageType["WARNING"] = "WARNING";
    MessageType["SUCCESS"] = "SUCCESS";
    MessageType["INFO"] = "INFO";
})(MessageType || (MessageType = {}));
